export const appendPlatformToken = (
  platformUrl: string,
  platformToken: string,
): string => {
  if (!platformUrl.includes("#")) {
    const url = new URL(platformUrl);
    url.searchParams.set("tkn", platformToken);
    return url.toString();
  }

  const [base, hash = ""] = platformUrl.split("#");
  const [hashPath, hashQuery = ""] = hash.split("?");
  const params = new URLSearchParams(hashQuery);
  params.set("tkn", platformToken);

  return `${base}#${hashPath}?${params.toString()}`;
};
